export class MwSelectorModel {
  value: number;
  text: string;
  isActive?: boolean;

  constructor(value: number, text: string, isActive: boolean = null) {
    this.value = value;
    this.text = text;
    this.isActive = isActive;
  }
}
